import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { ContainerPerson, ContainerTitle } from "./Person.styled";
import { ContactActions } from "../Pets/ContactActions";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { CaretDown } from "@phosphor-icons/react";
import { calculateAge, formatPhoneNumber } from "../../../utils/functions";
import { DatosMedicos } from "./DatosMedicos";
import { DatosCoberturaMedica } from "./DatosCoberturaMedica";
import { EditPerson } from "./EditPerson/EditPerson";
import CurrentUserContext from "../../../contexts/CurrentUserContext";

export const Person = ({ person }) => {
  const { userData } = useContext(CurrentUserContext);
  const owner = userData?.email === person?.email;

  const {
    name,
    birthdate,
    description,
    cel: mainNumber,
    tel: secondaryNumber,
    email,
  } = person;

  const getAge = () => {
    if (birthdate) return calculateAge(birthdate);
  };

  return (
    <ContainerPerson disableGutters maxWidth={"sm"}>
      <Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContainerTitle owner={owner}>
            {name}
            {birthdate && <br />}
            {birthdate && `Edad: ${getAge()}`}
          </ContainerTitle>
          {owner && <EditPerson data={person} />}
        </Box>

        <DatosMedicos person={person} />
        <DatosCoberturaMedica person={person} />

        {description && (
          <Accordion sx={{ marginTop: 2 }}>
            <AccordionSummary
              expandIcon={<CaretDown size={32} />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography fontWeight={700}>Mas Información</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ textAlign: "left" }}>
              {description}
            </AccordionDetails>
          </Accordion>
        )}

        {mainNumber && (
          <ContactActions
            number={mainNumber}
            name={name}
            label={" Contacto principal de emergencia"}
          />
        )}
        {secondaryNumber && (
          <Box mt={2}>
            <ContactActions
              number={secondaryNumber}
              name={name}
              label={"Contacto secundario  de emergencia"}
            />
          </Box>
        )}
        <Accordion sx={{ marginTop: 2 }}>
          <AccordionSummary
            expandIcon={<CaretDown size={32} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography fontWeight={700}>
              Datos de contacto de emergencia
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ textAlign: "left" }}>
            <Typography fontWeight={700}>
              {mainNumber && (
                <span>
                  Contacto principal de emergencia:{" "}
                  {formatPhoneNumberIntl(formatPhoneNumber(mainNumber))}
                  <br />
                </span>
              )}

              {secondaryNumber && (
                <span>
                  Contacto secundario:{" "}
                  {formatPhoneNumberIntl(formatPhoneNumber(secondaryNumber))}
                  <br />
                </span>
              )}

              {email && <span> Email: {email}</span>}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </ContainerPerson>
  );
};
